import { render } from "./wDialog.vue?vue&type=template&id=586648fe&scoped=true"
import script from "./wDialog.vue?vue&type=script&lang=js"
export * from "./wDialog.vue?vue&type=script&lang=js"

import "./wDialog.vue?vue&type=style&index=0&id=586648fe&lang=scss&scoped=true"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586648fe"]])

export default __exports__